


import SECTION_1676511135550 from
'../dynamic_section/dynamic_2/template_01';






import HowItWorkSection from '../sections/how_it_work/template_01';






import SECTION_FOOTER_BANNER from
'../dynamic_section/dynamic_2/template_01';



import "./style.css";


const HowItWorkPage = ()=>{
return (
  <div id="howItWorkPage" class="page ">
  
  

  
  < SECTION_1676511135550 desktopToggle={ true }
    mobileToggle={ false } label={ `tnc_title` } id={ `howitwork_title` } supportLanguage={
    false } titleToggle={ false } titleIconToggle={
    true } linkTo={ `` } addContainer={ false } />
  
  
  
  

  
  <HowItWorkSection desktopTitleToggle={ false }
    mobileTitleToggle={ true } />
  
  
  
  

  
  < SECTION_FOOTER_BANNER desktopToggle={ true }
    mobileToggle={ false } label={ `Dynamic Section2` } id={ `mall_step` } supportLanguage={
    false } titleToggle={ false } titleIconToggle={
    true } linkTo={ `` } addContainer={ false } />
  
  < SECTION_FOOTER_BANNER desktopToggle={ false }
    mobileToggle={ true } label={ `Dynamic Section2` } id={ `mall_step_m` } supportLanguage={
    false } titleToggle={ false } titleIconToggle={
    true } linkTo={ `` } addContainer={ false } />
  
</div>
)
}

export default HowItWorkPage;